import { createValidIcon } from '@ui/icons/utils/type-helper'

export const StatusCompletedIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.66669 10C1.66669 5.39762 5.39765 1.66666 10 1.66666C14.6024 1.66666 18.3334 5.39762 18.3334 10C18.3334 14.6024 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6024 1.66669 10ZM10 3.33333C6.31812 3.33333 3.33335 6.3181 3.33335 10C3.33335 13.6819 6.31812 16.6667 10 16.6667C13.6819 16.6667 16.6667 13.6819 16.6667 10C16.6667 6.3181 13.6819 3.33333 10 3.33333ZM14.3393 7.32741C14.6647 7.65285 14.6647 8.18048 14.3393 8.50592L9.75594 13.0893C9.43051 13.4147 8.90287 13.4147 8.57743 13.0893L6.4941 11.0059C6.16866 10.6805 6.16866 10.1528 6.4941 9.82741C6.81953 9.50197 7.34717 9.50197 7.67261 9.82741L9.16669 11.3215L13.1608 7.32741C13.4862 7.00197 14.0138 7.00197 14.3393 7.32741Z'
        fill={color}
      />
    </svg>
  )
})
